/** @type {(href?: string) => href is `#${string}`} */
export const isAnchorLink = href =>
	typeof href === "string" && href.startsWith("#") && href.length > 1;
